export function getServerBasePath() {
    if(window.location.host === 'simple-sale.co.il') {
        return 'https://api.simple-sale.co.il'
    }
    else if(window.location.host === 'www.simple-sale.co.il') {
        return 'https://api.simple-sale.co.il'
    }
    else if(window.location.host === 'qmobile.simple-sale.co.il') {
        return 'https://api.simple-sale.co.il'
    }
    else if(window.location.host === 'allsim.simple-sale.co.il') {
        return 'https://api.simple-sale.co.il'
    }
    else if(window.location.host === 'all-sim.simple-sale.co.il') {
        return 'https://api.simple-sale.co.il'
    }
    else if(window.location.host === 'tenecom.simple-sale.co.il') {
        return 'https://api.simple-sale.co.il'
    }
    else if(window.location.host === 'onestop.simple-sale.co.il') {
        return 'https://api.simple-sale.co.il'
    }
    else if(window.location.host === 'simple-sale.smartbid.tech') {
        return 'https://simple-sale-api.smartbid.tech';
    }
    //return 'https://api.simple-sale.co.il';

    return 'http://phone-lead.smart-bid.localhost:9000';
}

export const isMobile = () => window.matchMedia && window.matchMedia("(max-width: 480px)").matches;

export const ListManagersAddStore = [31, 548, 683, 931, 1007, 1011, 1244, 1438, 1480, 1487, 1527];


export const ListManagersFeatures = [2, 106, 633, 701, 721, 724, 744, 828, 855, 1025, 1309, 1387];


export const ListUserTypes =
    [
        {id:-1, name: ""},
        {id: 1, name: "Store"},
        {id: 2, name: "ManagerCellular"},
        {id: 3, name: "Admin"},
        {id: 4, name: "ManagerTVOrInternet"},
        {id: 5, name: "ManagerCellular012"},
        {id: 6, name: "ManagerInternet018"}
    ];

export const ListUserNameHe =
    [
        {id:-1, name: ""},
        {id: 1, name: "חנות"},
        {id: 2, name: "סלולר"},
        {id: 3, name: "אדמין"},
        {id: 4, name: "אינטרנט\\טלויזיה"},
        {id: 5, name: "סלולר 012"},
        {id: 6, name: "אקספון 018"}
    ];

export const DealsTypesHe =
    [
        {id:-1, name: ""},
        {id: 1, name: "חדש"},
        {id: 2, name: "פעיל"},
        {id: 3, name: "לא פעיל"},
        {id: 4, name: "הזמנה עלתה"} //"בוצע חלקית"}
    ];

export const ListUserTypesEnum = {};

for (var currUserTypeIndex in ListUserTypes){
    ListUserTypesEnum[ListUserTypes[currUserTypeIndex].name] = ListUserTypes[currUserTypeIndex].id;
}
